export interface Die {
  id           : string,
  isAvailable  : boolean,
  version      : number,
  name         : string,
  template_id  : string,
  tph          : number,
  usage_stats  : string,
  die_pressures: DiePressure[],
  horizon_id   : string,
  horizon_id_updatedAt: string,
  comment: string,
  updatedAt    : string
  laser_enabled : boolean
};

export interface DiePressure {
  subAssemblyID     : string,
  subAssemblySKU    : string,
  subAssemblyName   : string,
  currentPressure   : number,
  defaultPressure   : number,
  diePressureRecords: DiePressureRecord[]
}

export interface DiePressureRecord {
  oldPressure: number,
  newPressure: number,
  user       : string,
  order      : string,
  job        : string,
  timestamp  : string
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/models/die.model.ts